import React from 'react';

const MentorsPage = () => (
  <div class="container">
    <h1>Mentors from Pharo Consortium</h1>
  </div>
);

export default MentorsPage;
